export default "__VITE_ASSET__tVR0jsyq__"